// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 4H10V10H7V20H5V10H2V4ZM14 4H22V10H19V20H17V10H14V4ZM12.6356 12.0861L16.3848 16L12.6356 19.9139L11.1914 18.5304L12.6573 17H8V15H12.6573L11.1914 13.4696L12.6356 12.0861Z"}}]};

const SequenceFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sequence-filled',
    ref,
    icon: element,
  },
));

SequenceFilledIcon.displayName = 'SequenceFilledIcon';

export default SequenceFilledIcon;
